import { render } from "./PendingInvitesPage.vue?vue&type=template&id=87df238a&ts=true"
import script from "./PendingInvitesPage.vue?vue&type=script&lang=ts"
export * from "./PendingInvitesPage.vue?vue&type=script&lang=ts"

import "./PendingInvitesPage.vue?vue&type=style&index=0&id=87df238a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__